import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

import { Constants } from '../constants';
import { IToken } from '../models/index';

@Injectable()
export class TokenService {
    constructor(@Inject(HttpClient) private http: HttpClient) { }

    public async checkToken() {
        if (moment().isAfter(moment(sessionStorage.getItem('token_expires_date')))) {
            const data: IToken = {
                access_token: sessionStorage.getItem('bearer-token'),
                refresh_token: sessionStorage.getItem('refresh-token')
            };
            const tokenData = await this.getToken();
            sessionStorage.setItem('bearer-token', tokenData.access_token);
            sessionStorage.setItem('refresh-token', tokenData.refresh_token);
            return true;
        }
        return true;
    }

    public async getToken() {
        const options = {
            headers: new HttpHeaders({
                noToken: 'noToken'
            })
        };
        const body = new URLSearchParams();
        body.set('refresh_token', sessionStorage.getItem('refresh-token'));
        body.set('grant_type', 'refresh_token');
        const response = await this.http
            .post<IToken>(`${Constants.baseUrl}${Constants.tokenEndPoint}`, body.toString(), options);
        return response.toPromise();
    }
}

